import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    // Auto-scroll to the shared note with smooth behavior
    setTimeout(() => {
      this.element.scrollIntoView({ 
        behavior: 'smooth', 
        block: 'center',
        inline: 'nearest'
      })
    }, 200) // Small delay to ensure DOM is ready

    // Add a gentle highlight effect
    setTimeout(() => {
      this.addHighlightEffect()
    }, 500)
  }

  addHighlightEffect() {
    // Add a subtle pulsing effect
    let pulseCount = 0
    const pulseInterval = setInterval(() => {
      this.element.style.transition = 'box-shadow 0.5s ease-in-out'
      this.element.style.boxShadow = '0 0 20px rgba(255, 193, 7, 0.6)'
      
      setTimeout(() => {
        this.element.style.boxShadow = '0 0 10px rgba(255, 193, 7, 0.3)'
      }, 500)

      pulseCount++
      if (pulseCount >= 3) {
        clearInterval(pulseInterval)
        // Keep a subtle glow
        setTimeout(() => {
          this.element.style.boxShadow = '0 0 5px rgba(255, 193, 7, 0.2)'
        }, 1000)
      }
    }, 1000)
  }

  disconnect() {
    // Clean up any ongoing effects
    this.element.style.boxShadow = ''
    this.element.style.transition = ''
  }
} 